<ng-container>
    <div class="auth-page-wrapper pt-5">
<router-outlet></router-outlet>
<app-footer></app-footer>
</div>
</ng-container>